import React from "react";

export interface DescriptionProps {}

const Description: React.FC<DescriptionProps> = ({ children, ...props }) => {
	return <small className="description">{children}</small>;
};

export default Description;
